export default __webpack_public_path__ + "static/media/TITAN.350d62da.svg";